import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function invalidMarketPeriodBuilder({parsedStatusObj}) {
  const currentPeriod = parsedStatusObj.currentPeriod;
  const addTradePlanTime = parsedStatusObj.addTradePlanTime;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot add a trade plan at this time because market status is:
        {currentPeriod ? currentPeriod : ''}. Try again after {addTradePlanTime}
        .
      </Body3>
    </td>
  );
}
